import * as Sentry from '@sentry/react';

import BEM from '../../../common/bem';
import { ReactComponent as PriorityIcon } from '../../../common/images/priority-icon.svg';

const classes = BEM.with('ErrorBoundary');

type SentryFallbackRenderProps = Parameters<Sentry.FallbackRender>[0];

type ErrorBoundaryFallbackProps = {
  relayError: () => void;
  resetMessengerState: () => void;
} & SentryFallbackRenderProps;

export const ErrorBoundaryFallback = (props: ErrorBoundaryFallbackProps) => {
  const { resetMessengerState } = props;

  return (
    <div className={classes()}>
      <div className={classes('container')}>
        <div className={classes('content')}>
          <PriorityIcon className={classes('header-icon')} />
          <div className={classes('title-text')}>Something went wrong.</div>
          <div className={classes('title-subtext')}>
            {"We've been notified of this issue."}
            <br />
            {"Please hit 'Refresh' below to try again."}
          </div>
        </div>
        <div className={classes('refresh-btn')} onClick={resetMessengerState}>
          Refresh
        </div>
      </div>
    </div>
  );
};
